import { Contract } from './contract.model';

export class User {
  constructor(
    public id: number,
    public firstName: string,
    public lastName: string,
    public email: string,
    public language: string,
    public active: boolean,
    public description?: string,
    public activeUntil?: any,
    public contracts?: Contract[],
    public name?: string // firstname + lastname
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts